// Дерево папок «Моих тренировок». API отдает плоский список { id, name, parent_id,
// workouts_count }, здесь он собирается в дерево. Корень раздела — id = null

const byName = (a, b) => a.name.localeCompare(b.name, undefined, { sensitivity: 'base', numeric: true });

// rootWorkoutsCount — тренировки без папки, их видно только в корне
export const buildFolderTree = (folders, rootWorkoutsCount = 0) => {
  const byId = new Map(folders.map((folder) => [folder.id, folder]));
  const children = new Map([[null, []]]);
  folders.forEach((folder) => children.set(folder.id, []));
  folders.forEach((folder) => {
    // Родителя нет в списке — показываем папку в корне, а не теряем
    const parentId = byId.has(folder.parent_id) ? folder.parent_id : null;
    children.get(parentId).push(folder);
  });
  children.forEach((list) => list.sort(byName));

  // Тренировок в папке вместе со всеми вложенными
  const totals = new Map();
  const total = (id) => {
    if (totals.has(id)) return totals.get(id);
    const own = id === null ? 0 : byId.get(id).workouts_count;
    const sum = own + children.get(id).reduce((acc, child) => acc + total(child.id), 0);
    totals.set(id, sum);
    return sum;
  };
  folders.forEach((folder) => total(folder.id));
  const rootTotal = rootWorkoutsCount + total(null);

  return { byId, children, totals, rootTotal };
};

// Путь от корня до папки включительно
export const folderPath = (tree, id) => {
  const path = [];
  let node = tree.byId.get(id);
  while (node && path.length <= tree.byId.size) {
    path.unshift(node);
    node = tree.byId.get(node.parent_id);
  }
  return path;
};

export const descendantIds = (tree, id) => {
  const ids = new Set();
  const walk = (parentId) => {
    tree.children.get(parentId)?.forEach((child) => {
      ids.add(child.id);
      walk(child.id);
    });
  };
  walk(id);
  return ids;
};

// Плоский список для <select> с отступом по глубине; exclude — папка, которую
// переносим: ни она сама, ни ее подпапки целью быть не могут
export const folderOptions = (tree, exclude = null) => {
  const banned = exclude === null ? new Set() : new Set([exclude, ...descendantIds(tree, exclude)]);
  const options = [];
  const walk = (parentId, depth) => {
    tree.children.get(parentId).forEach((folder) => {
      if (banned.has(folder.id)) return;
      options.push({ id: folder.id, label: `${'   '.repeat(depth)}${folder.name}` });
      walk(folder.id, depth + 1);
    });
  };
  walk(null, 0);
  return options;
};

// ?folder=<id> в адресе раздела; корень — без параметра
export const folderUrl = (id) => (id ? `/workouts?folder=${id}` : '/workouts');

export const DRAG_WORKOUT = 'application/x-cvl-workout';
export const DRAG_FOLDER = 'application/x-cvl-folder';
